function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ic/LiveGreen"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Video_3021724"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M9.5 6L7.19 10H4V8C4 6.895 4.895 6 6 6H9.5Z",
  fill: "#118623"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  d: "M16 6L13.69 10H9.5L11.81 6H16Z",
  fill: "#118623"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  d: "M22.5 6L20.19 10H16L18.31 6H22.5Z",
  fill: "#118623"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  d: "M26 6C27.105 6 28 6.895 28 8V10H22.5L24.81 6H26Z",
  fill: "#118623"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28 25V12H4V25C4 26.105 4.895 27 6 27H26C27.105 27 28 26.105 28 25ZM20.4 18.84C20.765 19.465 20.55 20.27 19.92 20.63L14.39 23.825C14.19 23.94 13.965 24 13.735 24C13.01 24 12.42 23.415 12.42 22.69V16.31C12.42 16.08 12.48 15.855 12.595 15.655C12.96 15.03 13.76 14.815 14.385 15.175L19.92 18.355C20.12 18.4755 20.2855 18.6405 20.4 18.84Z",
  fill: "#118623"
})));

var SvgLiveG = function SvgLiveG(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLiveG, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LiveG.644e89a4.svg";
export { ForwardRef as ReactComponent };